export default __webpack_public_path__ + "static/media/area-chart.7181fb62.svg";